export const checkboxProps = {
    markerColor: "black",
    borderColor: "black",
    borderRadius: 0,
    markerSize: 3
}